/**
 * Service: posConfigPages
 */
angular.module('acme.common.service.posConfigPages', [
  'angularUUID2'
])
.service('PosConfigPagesService', ['uuid2', function(uuid2) {

  return {

    selectedPage: false,
    defaultPage: false,

    model: [],

    init: function() {
      return true;
    },

    create: function() {
      var page = {
        pageId: uuid2.newuuid(),
        configId: '',
        pageHeader: "Untitled Page " + (this.model.length + 1),
        name: '',
        pageNumber: (this.model.length + 1),
        description: '',
        defaultPage: '',
        items: []
      };

      this.model.push(page);

      return page;
    },

    remove: function(id) {
      this.model.splice(this.findPage(id).index, 1);
      this.updateOrder();
    },

    getModel: function() {
      return this.model;
    },

    setModel: function(pages) {
      this.model = (pages instanceof Array) ? pages : [];
    },

    // Get this.model.items
    getPageTiles: function(id) {
      var r = false,
          found = this.findPage(id);

      if (found) {
        if (found.page.items instanceof Array && found.page.items.length) {
          r = found.page.items;
        } else {
          r = found.page.items = [];
        }
      }

      return r;
    },

    removePageTile: function(id, tile) {
      var i, ii,
          page,
          found = this.findPage(id);

      if (found) {
        page = found.page;

        for (i=0,ii=page.items.length;i<ii;i++) {
          if (page.items[i].config.id === tile.config.id) {
            page.items.splice(i, 1);
            break;
          }
        }

        this.model[found.index] = page;
      }
    },

    findPage: function(id) {
      var i, ii,
        r = false;

      for (i=0,ii=this.model.length;i<ii;i++) {
        if (this.model[i].pageId === id) {
          r = {
            page: this.model[i],
            index: i
          };
          break;
        }
      }

      return r;
    },

    updatePage: function(page) {
      var found = this.findPage(page.pageId);

      if (found) {
        this.model[this.findPage(found.page.pageId).index] = page;
      }
    },

    setSelectedPage: function(id) {
      this.selectedPage = this.findPage(id).page.pageId;
    },

    getSelectedPage: function() {
      return this.findPage(this.selectedPage);
    },

    getSelectedPageId: function() {
      var r = false,
        p = this.getSelectedPage(this.selectedPage);

      if (p) {
        r = p.page.pageId;
      }

      return r;
    },

    clearSelectedPage: function() {
      this.selectedPage = false;
    },

    setDefaultPage: function(id) {
      this.defaultPage = this.findPage(id).page.pageId;
    },

    getDefaultPage: function() {
      return this.findPage(this.defaultPage);
    },

    getDefaultPageId: function() {
      var r = false,
        p = this.getDefaultPage(this.defaultPage);

      if (p) {
        r = p.page.pageId;
      }

      return r;
    },

    clearDefaultPage: function() {
      this.defaultPage = false;
    },

    getEmptyPages: function() {
      var i, ii,
          j, jj,
          hasTiles,
          r = [];

      for (i=0,ii=this.model.length;i<ii;i++) {
        if (this.model[i].items.length === 0) {
          r.push(this.model[i].pageHeader);
        }else{
          hasTiles = false;
          for (j=0,jj=this.model[i].items.length;j<jj;j++) {
            if (this.model[i].items[j].config.type !== 'tile') {
              hasTiles = true;
              break;
            }
          }
          if (!hasTiles) {
            r.push(this.model[i].pageHeader);
          }
        }
      }

      return r;
    },

    updateOrder: function() {
      var i, ii;

      for (i=0,ii=this.model.length;i<ii;i++) {
        this.model[i].pageNumber = i + 1;
      }
    },

    canDelete: function() {
      return this.model instanceof Array && this.model.length > 1;
    }

  };

}]);